module.exports = __webpack_public_path__ + "img/img-a1597862.9887a6df.png";